import * as api from '../../services/customization'

export const FETCH_CUSWJWS= 'FETCH_CUSWJWS';
export const FETCH_CUSWJWMAKE= 'FETCH_CUSWJWMAKE';




export const fetchCusWjws = (params, pagination, sort, extra) => {

    return {
        type: FETCH_CUSWJWS,
        payload: {
            promise: api.findCusWjws(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};
export const fetchCusWjwMake = (params, pagination, sort, extra) => {

    return {
        type: FETCH_CUSWJWMAKE,
        payload: {
            promise: api.findCusWjwMake(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/customization.js